var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card-actions',[_c('p',{staticClass:"md-layout-item"},[_vm._v("\n    Mostrando\n    "),_c('strong',[_vm._v("\n      "+_vm._s(_vm.pageSize * (_vm.localCurrentPage - 1))+"-"+_vm._s(_vm.pageSize * _vm.localCurrentPage)+"\n    ")]),_vm._v("\n    de\n    "),_c('strong',[_vm._v(_vm._s(_vm.total))]),_vm._v(" entradas\n  ")]),_vm._v(" "),_c('pagination',{staticClass:"pagination-no-border pagination-success",attrs:{"per-page":_vm.pageSize,"total":_vm.total},model:{value:(_vm.localCurrentPage),callback:function ($$v) {_vm.localCurrentPage=$$v},expression:"localCurrentPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Tables/TablePagination.vue